import type { ConfigData } from '@plone/volto/types';
import type { Middleware } from 'redux';
import authMiddleware from '../middleware/authMiddleware';

const applyMiddlewareConfig = (config: ConfigData): ConfigData => {
  if (!config.settings.storeExtenders) {
    config.settings.storeExtenders = [];
  }

  config.settings.storeExtenders.push(
    (middlewares: Middleware[]): Middleware[] => {
      const subscriptionsMiddleware: Middleware = (store) => (next) => (action) => {
        if (action.type === '@@INIT') {
          store.dispatch((config.subscriptionsAction?.()) as any);
        }
        return next(action);
      };
      
      return [...middlewares, authMiddleware, subscriptionsMiddleware];
    },
  );

  return config;
};

export default applyMiddlewareConfig;

